let tpl = `
    <div class="dd" style="display: none;">
        <div class="dd-inner">
            <% for(i = 0; i < mainCategory.length; i ++) {%>
            <div class="item">
                <h3>
                    <i class="<%=mainCategory[i].directoryIconV2%>"></i>
                    <a <% if(mainCategory[i].linkText && mainCategory[i].linkText != "javascript:;") { %> class="link" href="<%=mainCategory[i].linkText%>" target="_blank" <% } %>><%=mainCategory[i].text%></a>
                    <% if(mainCategory[i].imgLogo && mainCategory[i].imgLogo != "") { %>
                        <img src="<%=mainCategory[i].imgLogo%>" class="cat-icon">
                    <% } %>
                    <b class="arrow-right"></b>
                </h3>
                <% if(mainCategory[i].mainTextLink) {%>
                    <% for(j = 0; j < mainCategory[i].mainTextLink.length; j++) {%>
                        <h4><a target="_blank" href="<%=mainCategory[i].mainTextLink[j].linkText%>"><%=mainCategory[i].mainTextLink[j].text%></a></h4>
                    <%}%>
                <%}%>
                <div class="sub-menu">
                    <div class="sub-list">
                        <% if(mainCategory[i].popTwoCategory) { %>
                            <% for(k=0; k<mainCategory[i].popTwoCategory.length; k++) { %>
                                <dl class="slBlock">
                                    <dt class="liTitle">
                                        <a href="<%=mainCategory[i].popTwoCategory[k].linkText%>" target="_blank" clstag="firsttype|keycount|jdworldwidev2|fl<%=i+1%>-p<%=k+1%>"><%=mainCategory[i].popTwoCategory[k].text%></a>
                                    </dt>
                                    <% if(mainCategory[i].popTwoCategory[k].popThreeCategory) { %>
                                        <% for(l=0; l<mainCategory[i].popTwoCategory[k].popThreeCategory.length; l++) { %>
                                            <dd class="liItem ">
                                                <a href="<%=mainCategory[i].popTwoCategory[k].popThreeCategory[l].linkText%>" target="_blank" clstag="firsttype|keycount|jdworldwidev2|fl<%=i+1%>-p<%=k+1%>-<%=l+1%>"><%=mainCategory[i].popTwoCategory[k].popThreeCategory[l].text%></a>
                                            </dd>
                                        <% } %>
                                    <% } %>
                                    <span class="clr"></span>
                                </dl>
                                <% if(k != mainCategory[i].popTwoCategory.length-1) {%>
                                    <div class="split"></div>
                                <% } %>
                            <% } %>
                        <% } %>
                    </div>
                    <div class="sub-right">
                        <% if(mainCategory[i].categoryRecommendBrand) { %>
                            <div class="sr-mask <% if(mainCategory[i].categoryChannelLink || mainCategory[i].categoryRecommendBrand.length < 9) { %>normal<% } else { %>large<% } %>"></div>
                            <ul class="sub-brands clearfix">
                                <% for(j=0; j<mainCategory[i].categoryRecommendBrand.length; j++) { %>
                                    <% if(mainCategory[i].categoryChannelLink) {%>
                                        <% if(j < 8) { %>
                                            <li>
                                                <a href="<%=mainCategory[i].categoryRecommendBrand[j].linkText%>" target="_blank" clstag="firsttype|keycount|jdworldwidev2|fl<%=i+1%>-b<%=j+1%>">
                                                    <img src="//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif" data-original="<%=mainCategory[i].categoryRecommendBrand[j].imgLogo%>" class="lazy">
                                                </a>
                                            </li>
                                        <% } %>
                                    <% } else { %>
                                        <li>
                                            <a href="<%=mainCategory[i].categoryRecommendBrand[j].linkText%>" target="_blank" clstag="firsttype|keycount|jdworldwidev2|fl<%=i+1%>-b<%=j+1%>">
                                                <img src="//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif" data-original="<%=mainCategory[i].categoryRecommendBrand[j].imgLogo%>" class="lazy">
                                            </a>
                                        </li>
                                    <% } %>
                                <% } %>
                            </ul>
                            <ul class="sub-brands-link clearfix">
                                <% for(j=0; j<mainCategory[i].categoryRecommendBrand.length; j++) { %>
                                    <% if(mainCategory[i].categoryChannelLink) {%>
                                        <% if(j < 8) { %>
                                            <li>
                                                <a href="<%=mainCategory[i].categoryRecommendBrand[j].linkText%>" target="_blank" clstag="firsttype|keycount|jdworldwidev2|fl<%=i+1%>-b<%=j+1%>"></a>
                                            </li>
                                        <% } %>
                                    <% } else { %>
                                        <li>
                                            <a href="<%=mainCategory[i].categoryRecommendBrand[j].linkText%>" target="_blank" clstag="firsttype|keycount|jdworldwidev2|fl<%=i+1%>-b<%=j+1%>"></a>
                                        </li>
                                    <% } %>
                                <% } %>
                            </ul>
                        <% } %>
                        <% if(mainCategory[i].categoryChannelLink) { %>
                            <% for(j=0; j<mainCategory[i].categoryChannelLink.length; j++) { %>
                                <a target="_blank" href="<%=mainCategory[i].categoryChannelLink[0].linkText%>">
                                    <img src="//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif" data-original="<%=mainCategory[i].categoryChannelLink[0].actImg%>" class="sub-ad lazy" clstag="firsttype|keycount|jdworldwidev2|fl<%=i+1%>-ad">
                                </a>
                            <% } %>
                        <% } %>
                    </div>
                </div>
            </div>
            <%}%>
        </div>
    </div>
`;
exports.tpl = tpl;


// WEBPACK FOOTER //
// ./src/js/template/navMenuV2.js